import Article2Logo from 'images/news/swiper/media_fortune.png'
import Article1 from 'images/news/swiper/swiper1.jpg'
import Article1Logo from 'images/news/swiper/swiper1_logo.png'
import MobileArticle1 from 'images/news/swiper/swiper1_mobile.jpg'
import Article2 from 'images/news/swiper/swiper2.png'
import MobileArticle2 from 'images/news/swiper/swiper2_mobile.png'
import Article4 from 'images/news/swiper/swiper4.jpg'
import Article4Logo from 'images/news/swiper/swiper4_logo.png'
import MobileArticle4 from 'images/news/swiper/swiper4_mobile.jpg'
import Article5 from 'images/news/swiper/swiper5.jpg'
import Article5Logo from 'images/news/swiper/swiper5_logo.png'
import MobileArticle5 from 'images/news/swiper/swiper5_mobile.jpg'
import { StaticImageData } from 'next/image'

export interface NewsItem {
  id: number // 用来区别埋点的
  image: StaticImageData | string
  breadcrumb: string[]
  title: string
  url: string
}

export enum NewsCategory {
  GameEvents = 'Game Events',
  IndustryNews = 'Industry News',
  CompanyCulture = 'Company Culture',
  GameUpdates = 'Game Updates',
  GuidesAndTips = 'Guides and Tips',
}

export const NewsArticleMap = [
  {
    title: 'Avia Wins Silver 2025 TITAN Business Award for Excellence in Customer Service',
    description:
      'Avia wins Silver at the 2025 TITAN Business Awards for customer service excellence, reinforcing its leadership in casual mobile gaming with a player-first philosophy and over 300 million monthly tournaments.',
    url: 'https://www.prnewswire.com/news-releases/avia-wins-silver-2025-titan-business-award-for-excellence-in-customer-service-302430014.html?tc=eml_cleartime',
  },
  {
    title: "Avia's Office Cats Make Headlines in Fortune: A Unique Approach to Boosting Workplace Morale",
    description:
      "Fortune spotlights Avia's office cats, Tang Tang and Jiabao, and their impact on workplace morale. Featuring insights from Vickie and employee data, it’s a fun look at our unique office culture!",
    url: 'https://fortune.com/2025/02/21/this-company-found-unexpected-way-boost-office-morale-hired-two-cats/',
  },
  {
    title: 'Avia Launches First "Mom’s Week" to Celebrate Moms in Solitaire Clash',
    description:
      'Avia launches its first-ever Mom’s Week with in-game exclusives, real-life wish grants, mom-fluencer livestreams, giveaways, and a sweet boba collab.',
    url: 'https://www.prnewswire.com/news-releases/avia-launches-first-ever-moms-week-in-solitaire-clash-to-honor-moms-during-a-week-of-joy-connection-and-community-302448415.html',
  },
  {
    title: 'Vickie Chen, CEO of Avia – Interview Series',
    description:
      'Avia CEO Vickie Chen shares how she turned a garage startup into a global leader in skill-based mobile gaming, revealing her journey, the company’s growth to 60M+ downloads, and her vision for an accessible, competitive gaming future.',
    url: 'https://www.gaming.net/vickie-chen-ceo-of-avia-interview-series/',
  },
]

export const NewsArticleList = [
  {
    ...NewsArticleMap[0],
    image: Article4,
    media: Article4Logo,
  },
  {
    ...NewsArticleMap[1],
    image: Article2,
    media: Article2Logo,
  },
  {
    ...NewsArticleMap[2],
    image: Article1,
    media: Article1Logo,
  },
  {
    ...NewsArticleMap[3],
    image: Article5,
    media: Article5Logo,
  },
]

export const MobileNewsArticleList = [
  {
    ...NewsArticleMap[0],
    image: MobileArticle4,
  },
  {
    ...NewsArticleMap[1],
    image: MobileArticle2,
  },
  {
    ...NewsArticleMap[2],
    image: MobileArticle1,
  },
  {
    ...NewsArticleMap[3],
    image: MobileArticle5,
  },
]

export const NewsLetterSection = {
  title: 'Join Our Newsletter',
  description: 'Subscribe with your email to get the latest in-game events, news, and new game releases.',
  placeholder: 'Enter email address',
}
